import { TextComponent } from 'libs/end-to-end/src/text-component';
import { z } from 'zod';

export const TranslatedContent = z.union([z.string(), TextComponent.array()]);

export type TranslatedContent = z.infer<typeof TranslatedContent>;

export const concatTranslatedContent = (
  ...translatedContent: TranslatedContent[]
): TranslatedContent => {
  const textComponents: TextComponent[] = [];

  for (const content of translatedContent) {
    if (typeof content === 'string') {
      textComponents.push({ text: content });
    } else {
      textComponents.push(...content);
    }
  }

  return textComponents;
};

export const getTranslatedContentAsString = (
  translatedContent: TranslatedContent,
): string => {
  if (typeof translatedContent === 'string') {
    return translatedContent;
  }

  return translatedContent.map((component) => component.text).join('');
};
